import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withDetailedIcon } from '../DetailedIcon';
var innerSvg = '<rect class="DetailedIcon__secondary-color-fill" x="5" y="22" width="27" height="20" rx="1.946"/><path class="DetailedIcon__accent-color-fill" d="M24.143,28.071V23.857a1.286,1.286,0,0,0-2.572,0v4.214a2.572,2.572,0,1,0,2.572,0Z"/><path class="DetailedIcon__foreground-color-fill" d="M34.429,17.429h-18V9.714a5.148,5.148,0,0,1,5.142-5.143h2.572a5.149,5.149,0,0,1,5.143,5.143,1.286,1.286,0,1,0,2.571,0A7.736,7.736,0,0,0,24.143,2H21.571a7.737,7.737,0,0,0-7.714,7.714v7.715H11.286A2.579,2.579,0,0,0,8.714,20V35.429A2.579,2.579,0,0,0,11.286,38H34.429A2.579,2.579,0,0,0,37,35.429V20A2.579,2.579,0,0,0,34.429,17.429Zm0,18H11.286V20H34.429Z"/><path class="DetailedIcon__secondary-color-fill" d="M35,12a1,1,0,0,1-.707-1.707l2-2a1,1,0,0,1,1.414,1.414l-2,2A1,1,0,0,1,35,12Z"/><path class="DetailedIcon__secondary-color-fill" d="M38,15H36a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z"/>';
export var UnlockSVG = function UnlockSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
UnlockSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withDetailedIcon(UnlockSVG);